import { registerRootComponent } from 'expo';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import Main from './src/pages/Main';
import Menu from './src/pages/Menu';
import Reservation from './src/pages/Reservation';
import ReservationConfirm from './src/pages/ReservationConfirm';
import ResercationCancel from './src/pages/ReservationCancel';
import Header from './src/components/Header';
// import UserInfo from './src/pages/UserInfo';
import React from 'react';
import {
    type MainProps,
    type MenuProps,
    type ReservationProps,
    // type UserInfoProps,
    type ReservationConfirmProps,
    type ReservationCancelProps,
    type RootStackParamList,
} from './src/types/ScreenTypes';
import ScreenSizeProvider from './src/context/ScreenSizeContext';
import { LanguageProvider } from './src/context/LanguageContext';
import { createTheme, ThemeProvider } from '@rneui/themed';
import { extractHeaderTitle } from './src/utils/Utils';

const MainScreen: React.FC<MainProps> = ({ navigation, route }) => {
    return <Main navigation={navigation} route={route} />;
};

const MenuScreen: React.FC<MenuProps> = ({ navigation, route }) => {
    return <Menu navigation={navigation} route={route} />;
};

const ReservationScreen: React.FC<ReservationProps> = ({
    navigation,
    route,
}) => {
    return <Reservation navigation={navigation} route={route} />;
};

// const UserInfoScreen: React.FC<UserInfoProps> = ({ navigation, route }) => {
//     return <UserInfo navigation={navigation} route={route} />;
// };

const ReservationConfirmScreen: React.FC<ReservationConfirmProps> = ({
    navigation,
    route,
}) => {
    return <ReservationConfirm navigation={navigation} route={route} />;
};

const ReservationCancelScreen: React.FC<ReservationCancelProps> = ({
    navigation,
    route,
}) => {
    return <ResercationCancel navigation={navigation} route={route} />;
};

const Stack = createNativeStackNavigator<RootStackParamList>();

const theme = createTheme({
    lightColors: {
        primary: '#2089dc',
    },
    darkColors: {
        primary: 'black',
    },
});

export default function App() {
    const config = {
        screens: {
            // Main: '/',
            Reservation: '/',
            ReservationCancel: 'ReservationCancel/:reservation_id?',
        },
    };

    const linking = {
        prefixes: [],
        config,
    };

    return (
        <ScreenSizeProvider>
            <LanguageProvider>
                <ThemeProvider theme={theme}>
                    <NavigationContainer linking={linking}>
                        <Stack.Navigator
                            screenOptions={{
                                header: ({
                                    navigation,
                                    route,
                                    options,
                                    back,
                                }) => {
                                    return (
                                        <Header
                                            title={extractHeaderTitle()}
                                            back={back}
                                            navigation={navigation}
                                        />
                                    );
                                },
                            }}
                        >
                            {/* <Stack.Screen name="Main" component={MainScreen} /> */}
                            <Stack.Screen
                                name="Reservation"
                                component={ReservationScreen}
                            />
                            {/* <Stack.Screen name="UserInfo" component={UserInfoScreen} /> */}
                            <Stack.Screen
                                name="ReservationConfirm"
                                component={ReservationConfirmScreen}
                            />
                            <Stack.Screen
                                name="ReservationCancel"
                                component={ReservationCancelScreen}
                            />
                        </Stack.Navigator>
                    </NavigationContainer>
                </ThemeProvider>
            </LanguageProvider>
        </ScreenSizeProvider>
    );
}

registerRootComponent(App);
